import { LocalizationKeys, type LocalizationKey } from "../../i18n/keys";

/**
 * Language enum
 */
export enum Language {
  UNSPECIFIED = 0,
  RU = 1,
  EN = 2,
  ES = 3,
  FR = 4,
  DE = 5,
  ZH = 6,
  IN = 7,
  PT = 8,
}

/**
 * Мапинг Language enum на ключи локализации
 */
export const LANGUAGE_I18N_KEYS: Record<Language, LocalizationKey> = {
  [Language.UNSPECIFIED]: LocalizationKeys.LANGUAGE_SYSTEM,
  [Language.RU]: LocalizationKeys.LANGUAGE_RU,
  [Language.EN]: LocalizationKeys.LANGUAGE_EN,
  [Language.ES]: LocalizationKeys.LANGUAGE_ES,
  [Language.FR]: LocalizationKeys.LANGUAGE_FR,
  [Language.DE]: LocalizationKeys.LANGUAGE_DE,
  [Language.ZH]: LocalizationKeys.LANGUAGE_ZH,
  [Language.IN]: LocalizationKeys.LANGUAGE_IN,
  [Language.PT]: LocalizationKeys.LANGUAGE_PT,
} as const;
